import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiError } from "../context/AuthContext";
import { UserPlus, Sparkle } from "@phosphor-icons/react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    setLoading(true);
    try {
      await register(email.trim(), password, name.trim());
      toast.success("Account created — let's flip!");
      navigate("/dashboard");
    } catch (e) {
      toast.error(formatApiError(e, "Could not create account"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-6 py-16">
      <div className="nb-card bg-[#D4C4FB]">
        <span className="nb-label">Join ReFlip</span>
        <h1 className="mt-2 font-display text-4xl font-black tracking-tighter">Create an account</h1>
        <p className="mt-2 text-sm font-medium text-[#1A1A1A]">
          Buy great second-hand finds or list your closet in seconds.
        </p>
        <form className="mt-6 space-y-4" onSubmit={onSubmit}>
          <div>
            <label className="nb-label">Display name</label>
            <input
              data-testid="register-name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="nb-input mt-2"
            />
          </div>
          <div>
            <label className="nb-label">Email</label>
            <input
              data-testid="register-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="nb-input mt-2"
            />
          </div>
          <div>
            <label className="nb-label">Password</label>
            <input
              data-testid="register-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="nb-input mt-2"
            />
          </div>
          <button
            data-testid="register-submit"
            type="submit"
            disabled={loading}
            className="nb-btn flex w-full items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading ? <Sparkle className="animate-spin" /> : <UserPlus weight="bold" size={18} />} Create account
          </button>
        </form>
        <div className="mt-4 text-xs font-bold uppercase tracking-wider">
          <Link to="/login" className="underline hover:no-underline">
            Already have an account? Log in
          </Link>
        </div>
      </div>
    </div>
  );
}
